import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { BillingReport } from '../../../clients.models';
import { BillingReportСomponent } from "../../components/billing-report/billing-report";
import { env } from '../../../../../env/env';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'current-billing-report-dialog',
  templateUrl: './current-billing-report-dialog.html',
  styleUrl: './current-billing-report-dialog.css',
  imports: [
    AsyncPipe,
    BillingReportСomponent
  ]
})
export class CurrentBillingReportDialog {
  constructor(
    private httpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: { clientId: string }) { }
  public billingReport$: Observable<BillingReport> | null = null;

  public ngOnInit() {
    this.loadCurrentBillingReport();
  }

  private loadCurrentBillingReport() {
    this.billingReport$ = this.httpClient.get<BillingReport>(`${env.apiUrl}/clients/${this.data.clientId}/payment/report`);
  }
}
